import React,{forwardRef} from 'react'
import ProductFeatureAssociationSetupForm from './ProductFeatureAssociationSetupForm'

const AddProductFeatureAssociation = forwardRef((props, ref) => {
    const {
        formValidateError,
        formData,
        associatedDate,
        updateAssociationData,
        isButtonLoader
    } = props;
    return (
        <>
            <ProductFeatureAssociationSetupForm
                formValidateError = {formValidateError}
                formData={formData}
                associatedDate={associatedDate}
                updateAssociationData={updateAssociationData}
                formActionType={'insert'}
                isInfoOpenHandler={props.isInfoOpenHandler}
                ref={ref}
                isButtonLoader={isButtonLoader}
            />
        </>
    )
})

export default AddProductFeatureAssociation